import validate from "/opt/apps/.build/node_modules/.pnpm/nuxt@3.12.4_eslint@8.57.0_rollup@4.21.0_sass@1.69.5_typescript@5.5.4_vite@5.4.1/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "employee-activation": () => import("/opt/apps/.build/packages/nuxt/layers/employee/middleware/employeeActivation.ts"),
  protected: () => import("/opt/apps/.build/packages/nuxt/layers/auth/middleware/protected.ts")
}